import { jsx as t } from "react/jsx-runtime";
import { TranslationContext as n } from "./context.js";
function a({
  children: r,
  locale: o
}) {
  return /* @__PURE__ */ t(
    n.Provider,
    {
      value: {
        locale: o
      },
      children: r
    }
  );
}
export {
  a as TranslationProvider
};
